import React, { Component } from 'react';

class CategoryContent extends Component
{
	_onClick(e){
		this.props.onClick(e);
	}


	render()
	{
		return (
			<li onClick={this._onClick.bind(this)} data-category-parent-id="26" className="category-album col-4 references-tabs-" data-post-id={this.props.id} id={this.props.id}>
				<div className="album-box img-box">
					<h3 className="cat-name">{this.props.title}</h3>
					<img src={this.props.image} alt={this.props.title}/>
				</div>
			</li>
		)
	}


}

export default CategoryContent;



// WEBPACK FOOTER //
// ./src/component/CategoryContent.js